var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Reusable Text Input component
 *
 * TODOs(Carter):
 *   - Support for error message + onLeave validation function
 *   - Add left/right element functionality for logos
 *   - Extend to other specific inputs
 */
import React from 'react';
import { ErrorText, StyledInput, TextInputContainer } from './TextInput.styled';
function TextInput(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, _d = _a.width, width = _d === void 0 ? undefined : _d, _e = _a.height, height = _e === void 0 ? undefined : _e, _f = _a.inputSize, inputSize = _f === void 0 ? 'large' : _f, _g = _a.placeholder, placeholder = _g === void 0 ? '' : _g, _h = _a.value, value = _h === void 0 ? '' : _h, _j = _a.type, type = _j === void 0 ? 'text' : _j, _k = _a.errorText, errorText = _k === void 0 ? '' : _k, _l = _a.onChange, onChange = _l === void 0 ? function (e) {
        e.preventDefault();
    } : _l, rest = __rest(_a, ["disabled", "invalid", "width", "height", "inputSize", "placeholder", "value", "type", "errorText", "onChange"]);
    return (React.createElement(TextInputContainer, null,
        React.createElement(StyledInput, __assign({ type: type, placeholder: placeholder, value: value, disabled: disabled, inputSize: inputSize, width: width, onChange: disabled
                ? function (e) {
                    e.preventDefault();
                }
                : function (e) {
                    if (onChange) {
                        onChange(e);
                    }
                } }, rest)),
        errorText !== '' && invalid ? React.createElement(ErrorText, null, errorText) : null));
}
export default TextInput;
